module.exports = __webpack_public_path__ + "img/ta-right-icon.14e07489.svg";